/**
 * Fornisce un observer per gestire le chiamate su evento in tutto il frontend
 */

type UnsubscribeFn = () => void;
type ObserverCallback = (data: any, unsubscribe: UnsubscribeFn) => void;

const Observer = {
    events: {} as Record<string, ObserverCallback[]>,
    subscribe: (tag: string, cb: ObserverCallback): void => {
        Observer.events[tag] = (Observer.events[tag] || []).filter(C => C !== cb).concat(cb);
    },
    uniquesubscribe: (tag: string, cb: ObserverCallback): void => {
        Observer.events[tag] = [cb];
    },
    unsubscribe: (tag: string, cb: ObserverCallback): void => {
        Observer.events[tag] = (Observer.events[tag] || []).filter(C => C !== cb);
    },
    notify: (tag: string, data: any): void => {
        (Observer.events[tag] || []).forEach(cb => cb(data, () => Observer.unsubscribe(tag, cb)));
    },
    monosubscribe: (tag: string, cb: (data: any) => any): void => {
        Observer.events[tag] = (Observer.events[tag] || []).concat((data: any, unsubscribe: UnsubscribeFn) => {
            (unsubscribe as Function)(cb(data));
        });
    }
};

export default Observer;